import React, {Component} from 'react';
import {connect} from 'react-redux';

import OwnerBasic from './OwnerBasic';
import OwnerProperty from './OwnerProperty';
import OwnerReach from './OwnerReach';

class FlowContainer extends Component {
    state = {
        active: 0,
        reach: null
    };

    step = (val) => {
        this.setState({active: this.state.active + val});
    };

    setReach = (reach) => {
        this.setState({reach: reach});
    };

    render() {
        return (
            <div>
                {
                    this.state.active === 0 && <OwnerBasic onContinue={() => this.step(1)}/>
                }
                {
                    this.state.active === 1 && <OwnerProperty onContinue={() => this.step(1)} setReach={this.setReach}/>
                }
                {
                    this.state.active === 2 && <OwnerReach onContinue={() => this.step(1)} reach={this.state.reach} owner={this.props.activeUser}/>
                }
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    activeUser: state.activeUser
});

export default connect(mapStateToProps)(FlowContainer);


// WEBPACK FOOTER //
// ./src/containers/authentication/OwnerRegisterFlow/FlowContainer.js